module.exports = __webpack_public_path__ + "img/116ne.191947c6.svg";